'use client'

import { mergeProps } from '@base-ui/react/merge-props'
import { useRender } from '@base-ui/react/use-render'

import { cn, cva } from '@eigtech/ui/lib/utils'
import { VariantProps } from 'class-variance-authority'

const labelVariants = cva(
  'text-foreground text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50 [&:has(input[type="checkbox"]:not(:disabled))]:cursor-pointer',
  {
    variants: {
      variant: {
        primary: 'font-medium',
        secondary: 'font-normal',
      },
    },
    defaultVariants: {
      variant: 'primary',
    },
  }
)

function Label({
  className,
  render,
  variant,
  onMouseDown,
  ...props
}: useRender.ComponentProps<'label'> & VariantProps<typeof labelVariants>) {
  const defaultProps: useRender.ElementProps<'label'> & {
    [key: `data-${string}`]: string | number | null | undefined
  } = {
    className: cn(labelVariants({ variant }), className),
    'data-slot': 'label',
    // TODO: Determine if needed; this was part of the old Radix component
    onMouseDown(event) {
      // only prevent text selection if clicking inside the label itself
      const target = event.target as HTMLElement
      if (target.closest('button, input, select, textarea')) return

      onMouseDown?.(event)

      // prevent text selection when double clicking label
      if (!event.defaultPrevented && event.detail > 1) event.preventDefault()
    },
  }

  return useRender({
    defaultTagName: 'label',
    render,
    props: mergeProps<'label'>(defaultProps, props),
  })
}

export { Label }
